import React from "react";

import QueryProvider from "./src/providers/QueryProvider";

export const wrapRootElement = ({ element }) => (
  <QueryProvider>{element}</QueryProvider>
);
